import styled from 'styled-components';
import TableCell from '@mui/material/TableCell';
import Pagination from '@mui/material/Pagination';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DateRange } from 'react-date-range';
import FormControl from '@mui/material/FormControl';
import { mediaQueries } from '../../constants/breakpoints';

export const AgentPerformancesContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 100%;
  overflow-y: auto;
  @media ${mediaQueries.desktop} {
    height: calc(100% - 30px);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    margin: 15px;
    border-radius: 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 20px;
  background: #fff;
  border-radius: 6px;
  @media ${mediaQueries.desktop} {
    margin: 24px 80px;
  }
`;

export const Actions = styled.div`
  display: flex;
  margin: 20px 20px 0;
  flex-direction: column;
  @media ${mediaQueries.desktop} {
    flex-direction: row;
    justify-content: space-between;
    > div {
      flex: 1;
      display: flex;
      flex-direction: row;
    }
  }
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchContainer = styled.div`
  margin-right: 16px;
  width: 250px;
`;

export const StyledFormControl = styled(FormControl)`
  min-width: 200px;
`;

export const TableContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  overflow-x: auto;
  @media ${mediaQueries.desktop} {
    overflow-x: hidden;
  }
`;

export const DetailContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

export const DetailTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 500;
`;

export const DetailRow = styled.div`
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.div`
  font-weight: 500;
  width: 200px;
  flex-shrink: 0;
`;

export const DetailValue = styled.div`
  flex: 1;
`;

export const DetailSection = styled.div`
  margin-bottom: 30px;
  
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  width: 100%;
`;

export const ActionsContainer = styled(TableCell)`
  display: flex;
`;

export const Title = styled.h4`
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #050d42;
`;

export const StyledPagination = styled(Pagination)`
  ul {
    flex-wrap: nowrap;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  button {
    min-width: 48%;
    margin-bottom: 30px;
  }
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin: 0 auto;
`;

export const StyledButton = styled(Button)`
  min-width: 150px !important;
`;

export const StyledDetailsItem = styled.div`
  margin-bottom: 10px;
  text-align: left;
  font-size: 16px;
`;

export const DateInput = styled.div`
  height: 53px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  background-color: #fff;
  border-radius: 4px;
  padding: 8px 12px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 1rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  svg {
    font-size: 16px;
    position: relative;
    top: -1px;
  }
`;

export const StyledCalendarTodayIcon = styled(CalendarTodayIcon)`
  margin-right: 5px;
`;

export const StyledDateRange = styled(DateRange)`
  position: absolute;
  left: 0;
  top: 55px;
  border-radius: 10px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
`;
